/**
 * /frontend/src/features/analytics/api/bottleneckAnalyticsApi.js
 */

import { ANALYTICS_ENDPOINTS } from '../constants/analyticsEndpoints';
import { getJson } from './analyticsApiClient';

/**
 * Fetches bottleneck sections metrics.
 */
export const getBottleneckSections = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.BOTTLENECK_SECTIONS,
  { storeId, startDate, endDate },
  token,
  'analytics-bottleneck-sections'
);

/**
 * Fetches bottleneck zones metrics.
 */
export const getBottleneckZones = async (request, token, storeId, startDate, endDate) => getJson(
  request,
  ANALYTICS_ENDPOINTS.BOTTLENECK_ZONES,
  { storeId, startDate, endDate },
  token,
  'analytics-bottleneck-zones'
);

